import axioPath from "api/axioPath";
import axios from "axios";

export const getNotificationDetailsApi = (locType, cusId, token) => (dispatch) => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
      UserType: 'External',
      customerId: cusId
    },
  }).get(`/order/notification/details/${locType}`)
    .then((response) => {
      return response.data;
    })
    .catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};

export const markNotificationReadApi = (data, token) => (dispatch) => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
      UserType: 'External'
    },
  }).post('/order/notification/read', data)
    .then((response) => {
      return response.data;
    }).catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data };
      else return ex;
    });
};